import Overview from '@rebuild/materials/shared/widget_shell/Overview.vue';
import FullIndex from '@rebuild/materials/shared/widget_shell/FullIndex.vue';
import MobOverview from '@rebuild/materials/shared/widget_shell/MobOverview.vue';
import MobFull from '@rebuild/materials/shared/widget_shell/MobFull.vue';

export const componentMap = {
	overview: Overview,
	full: FullIndex,
	'mob-overview': MobOverview,
	'mob-full': MobFull
};
